module.exports = __webpack_public_path__ + "static/media/monitoring.9d3801be.png";